import { useForm } from '../../contexts/FormContext'
import { Button, SaveButton } from '../../components/common'
import { Input, Textarea, FileUpload } from '../../components/forms'
import './Step6Contact.css'

function Step6Contact() {
  const { formData, updateNestedFormData, goToNextStep, goToPreviousStep } = useForm()

  const canProceed = formData.contact.companyName && formData.contact.contactName && formData.contact.email

  return (
    <div className="step-section">
      {/* Section Header */}
      <div className="section-header">
        <h2>Step 6: Contact Information & Final Details</h2>
        <p className="section-subtitle">We're almost there! Let us know how to reach you and share any additional requirements.</p>
      </div>

      {/* Section Body */}
      <div className="section-body">
        {/* Contact Information */}
        <div className="form-block-section">
          <div className="form-block-header">
            <div className="form-block-icon">👤</div>
            <h3 className="form-block-title">Your Contact Information</h3>
          </div>
          <p className="form-block-desc">We'll use this information to send you the proposal, contract, and keep you updated throughout the project.</p>

          <div className="form-row-2col">
            <Input
              id="company-name"
              label="Company Name"
              required
              value={formData.contact.companyName}
              onChange={(e) => updateNestedFormData('contact.companyName', e.target.value)}
              placeholder="e.g., StartupHive Co., Ltd."
            />
            <Input
              id="contact-name"
              label="Your Name"
              required
              value={formData.contact.contactName}
              onChange={(e) => updateNestedFormData('contact.contactName', e.target.value)}
              placeholder="e.g., Tanaka Taro"
            />
          </div>

          <Input
            id="email"
            label="Email Address"
            type="email"
            required
            value={formData.contact.email}
            onChange={(e) => updateNestedFormData('contact.email', e.target.value)}
            placeholder="your.email@company.com"
            helperText="We'll send all project communications to this email"
          />
        </div>

        {/* Additional Requests */}
        <div className="form-block-section">
          <div className="form-block-header">
            <div className="form-block-icon">📝</div>
            <h3 className="form-block-title">Additional Requests & Comments</h3>
          </div>
          <p className="form-block-desc">Is there anything else we should know? Any special requirements, questions, or concerns?</p>

          <Textarea
            id="additional-requests"
            label="Additional requests, custom features, or questions"
            value={formData.additionalRequests.additionalNotes}
            onChange={(e) => updateNestedFormData('additionalRequests.additionalNotes', e.target.value)}
            placeholder="Share any additional requirements, custom features you need, questions, or special considerations..."
            rows={6}
            maxLength={2000}
            showCount
          />

          <div className="example-box">
            <div className="example-box-title">💡 Example requests:</div>
            <ul>
              <li>"We need integration with our existing CRM system (Salesforce)"</li>
              <li>"Can you add a members-only login area?"</li>
              <li>"We'd like to migrate content from our old website"</li>
              <li>"Need multilingual support (Japanese, English, Chinese)"</li>
              <li>"Do you offer training for our team to manage the website?"</li>
              <li>"We have a strict deadline for a product launch on [date]"</li>
            </ul>
          </div>

          <FileUpload
            id="additional-files"
            label="📎 Attach Files (optional)"
            accept=".pdf,.doc,.docx,.jpg,.png,.txt"
            multiple
            uploadType="additional"
            files={formData.additionalRequests.documents || []}
            onChange={(files) => updateNestedFormData('additionalRequests.documents', files)}
            helperText="For users who need to share specifications or reference materials"
          />

          <div className="info-box">
            <div className="info-box-title">
              <span>ℹ️</span>
              <span>Custom Development</span>
            </div>
            <p>For custom features or integrations, we'll review your requirements and provide a detailed quote with estimated hours (¥10,000/hour for custom coding).</p>
          </div>
        </div>
      </div>

      {/* Section Actions */}
      <div className="section-actions">
        <Button variant="secondary" size="md" onClick={goToPreviousStep}>
          ← Back
        </Button>
        <div className="actions-right">
          <SaveButton />
          <Button variant="primary" size="md" disabled={!canProceed} onClick={goToNextStep}>
            Review & Submit →
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Step6Contact
